t = require('views/internal/teacup-with-helpers')('board_new')

module.exports = ->
  t.form ->

    t.label { for: 'boardNewTitle' }, ->
      t.format 'title'
    t.input '.non-empty.js-autofocus', { id: 'boardNewTitle', type: 'text', name: 'name', placeholder: t.mustacheVar('placeholder'), value: t.mustacheVar('name'), dir: 'auto' }

    t.div { class: t.mustacheBlock('hideOrg', (-> 'hide')) }, ->
      t.div '.u-clearfix', ->
        t.label '.u-float-left', { style: 'margin-right: 8px;' }, ->
          t.format 'organization'
        t.mustacheBlock 'canAddToOrgs', ->
          t.a '.icon-sm.icon-information.dark-hover.js-helper-add-org', { href: '#' }

      t.mustacheBlockInverted 'canAddToOrgs', ->
        t.p '.quiet', { style: 'margin-bottom: 16px;' }, ->
          t.format 'organization-whisk-n-tsk'
          t.text ' '
          t.a '.js-create-org', { href: '#' }, ->
            t.format 'create-an-organization'

      t.select { name: 'org-id', class: t.mustacheBlockInverted('canAddToOrgs', (-> 'hide')) }, ->
        t.option { value: '' }, ->
          t.format 'none'
        t.mustacheBlock 'orgs', ->
          t.optionSelected t.mustacheVar('selectOrg'), { value: t.mustacheVar('id') }, ->
            t.text t.mustacheVar('displayName')

    t.input { type: 'hidden', name: 'permissionLevel', value: t.mustacheVar('pLevel') }

    t.p '.quiet.js-vis-display'

    t.ul '.pop-over-list.js-vis-chooser.hide'

    t.p '.error.u-bottom.js-no-valid-org-privs.u-clearfix.hide'

    t.mustacheBlock 'isCopyBoard', ->
      t.div '.check-div.u-clearfix', { style: 'margin-top: 10px;' }, ->
        t.input { type: 'checkbox', id: 'idKeepCards', name: 'cards', checked: true }
        t.label { for: 'idKeepCards' }, ->
          t.format 'keep-cards'
      t.p '.quiet', ->
        t.format 'activity-and-members-will-not-be-copied'

      t.mustacheBlock 'willRemovePowerUps', ->
        t.p '.quiet', ->
          t.format 'power-ups-will-not-be-copied'

    t.input '.primary.wide.js-submit.disabled', { type: 'submit', value: t.l('create') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_new.coffee